import * as React from 'react';
export var Tag = function (_a) {
    var label = _a.label, _b = _a.kind, kind = _b === void 0 ? 'default' : _b, children = _a.children;
    return (React.createElement("span", { className: "tag-label tag-label-".concat(kind) },
        label,
        children));
};
//# sourceMappingURL=index.js.map